import React, { useEffect, useRef, useState } from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import DinoRunnerGame from "./DinoRunnerGame";
import "./WaitingGameOffer.scss";

const WAITING_GAME_DELAY_MS = 5000;

interface Props {
  isWaiting: boolean;
}

export default function WaitingGameOffer({ isWaiting }: Props) {
  const [showPrompt, setShowPrompt] = useState(false);
  const [showGame, setShowGame] = useState(false);
  const [promptDismissed, setPromptDismissed] = useState(false);
  const timerRef = useRef<number | null>(null);

  useEffect(() => {
    if (timerRef.current) {
      window.clearTimeout(timerRef.current);
      timerRef.current = null;
    }

    if (!isWaiting) {
      setShowPrompt(false);
      setShowGame(false);
      setPromptDismissed(false);
      return undefined;
    }

    timerRef.current = window.setTimeout(() => {
      if (!promptDismissed) {
        setShowPrompt(true);
      }
    }, WAITING_GAME_DELAY_MS);

    return () => {
      if (timerRef.current) {
        window.clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };
  }, [isWaiting, promptDismissed]);

  const handleAcceptGame = () => {
    setShowPrompt(false);
    setShowGame(true);
  };

  const handleDeclineGame = () => {
    setShowPrompt(false);
    setPromptDismissed(true);
  };

  const handleCloseGame = () => {
    setShowGame(false);
  };

  return (
    <>
      <Modal
        isOpen={showPrompt}
        toggle={handleDeclineGame}
        centered
        className="waiting-game-offer__prompt-modal"
      >
        <ModalHeader toggle={handleDeclineGame}>¿Todavía esperando?</ModalHeader>
        <ModalBody>
          <p className="mb-2">
            La creación de contactos está tardando un poco más de lo habitual.
          </p>
          <p className="mb-0">
            ¿Querés jugar al clásico del dinosaurio mientras seguimos trabajando en segundo plano?
          </p>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" outline onClick={handleDeclineGame}>
            No, gracias
          </Button>
          <Button color="primary" onClick={handleAcceptGame}>
            ¡Sí, jugar!
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
        isOpen={showGame}
        toggle={handleCloseGame}
        size="lg"
        centered
        className="waiting-game-offer__game-modal"
      >
        <ModalHeader toggle={handleCloseGame}>
          Dino Wembii Runner
        </ModalHeader>
        <ModalBody>
          <p className="waiting-game-offer__game-note">
            El proceso sigue en segundo plano. Podés cerrar el juego cuando quieras.
          </p>
          <DinoRunnerGame />
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={handleCloseGame}>
            Volver a los leads
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}
